import { useState } from "react";
import Swal from "sweetalert2";
import "./assets/kanbanBoard.css";
import CardTaskKanban from "./components/CardTaskKanban";
import ModalTaskKanban from "./components/ModalTaskKanban";
import SidebarKanban from "./components/SidebarKanban";
import { useTaskCommand } from "./hooks/useTaskCommand";
import { useTasksQuery } from "./hooks/useTasksQuery";

function WorkPlanAndTraining() {
  const [isOpen, setIsOpen] = useState(false);
  const [filtersTasks, setFiltersTasks] = useState({
    type: "",
    startDate: "",
    endDate: "",
  });
  const { tasks: tasksPending, refresh: refreshPending } = useTasksQuery({
    status: "pendiente",
    ...filtersTasks,
  });
  const { tasks: tasksFinished, refresh: refreshFinished } = useTasksQuery({
    status: "completada",
    ...filtersTasks,
  });
  const {
    task,
    handleChangeTask,
    setDefaultTask,
    errors: { errors },
    createTask,
    updateTask,
    importTasks,
    deleteTask,
    supportFile,
    setSupportFile,
  } = useTaskCommand(() => {
    refreshPending();
    refreshFinished();
  });

  const toggleModal = (task) => {
    setIsOpen((prev) => !prev);
    setDefaultTask(task);
  };

  const handleSaveTask = () => {
    if (task.id) {
      updateTask().then((data) => {
        if (data) {
          toggleModal();
        }
      });
      return;
    }

    createTask().then((data) => {
      if (data) {
        toggleModal();
      }
    });
  };

  const handleChangeFilter = ({ name, value }) => {
    setFiltersTasks((prev) => ({ ...prev, [name]: value }));
  };

  const handleDeleteTask = async (id) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "No podrás revertir esto!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteTask(id);
      }
    });
  };

  return (
    <main className="main-container">
      <h1 className="h2 m-0 fw-bold">Plan de trabajo y capacitación</h1>
      <div className="d-md-flex gap-3 d-block">
        <SidebarKanban
          onAddTask={() => toggleModal()}
          onFilterChange={handleChangeFilter}
          onImportTask={importTasks}
        />
        <section className="kanban-board d-block d-md-flex">
          <div className="kanban-column">
            <header>Pendientes</header>
            <div className="kanban-cards-grid">
              {tasksPending.map((task) => (
                <CardTaskKanban
                  key={task.id}
                  {...task}
                  onClick={() => toggleModal(task)}
                  onDelete={() => handleDeleteTask(task.id)}
                />
              ))}
            </div>
          </div>
          <div className="kanban-column">
            <header>Completadas</header>
            <div className="kanban-cards-grid">
              {tasksFinished.map((task) => (
                <CardTaskKanban
                  key={task.id}
                  {...task}
                  onClick={() => toggleModal(task)}
                  onDelete={() => handleDeleteTask(task.id)}
                />
              ))}
            </div>
          </div>
        </section>
      </div>

      <ModalTaskKanban
        isOpen={isOpen}
        onClose={toggleModal}
        task={task}
        onChangeTask={handleChangeTask}
        errors={errors}
        onSaveTask={handleSaveTask}
        supportFile={supportFile}
        onChangeSupportFile={setSupportFile}
      />
    </main>
  );
}

export default WorkPlanAndTraining;
